import { render, staticRenderFns } from "./alarmDetail.vue?vue&type=template&id=44572332&scoped=true&"
import script from "./alarmDetail.vue?vue&type=script&lang=js&"
export * from "./alarmDetail.vue?vue&type=script&lang=js&"
import style0 from "./alarmDetail.vue?vue&type=style&index=0&id=44572332&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44572332",
  null
  
)

export default component.exports